import styled from 'styled-components';

export const ModalDescription = styled.p`
  color: ${(props) => props.theme.colors?.greys.darker};
  font: ${(props) => props.theme.fonts?.textBigHeight24};
  margin: 0;
`;

export const DownloadLink = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
  margin-top: 24px;
`;

export const DownloadLinkLabel = styled.span`
  font: ${(props) => props.theme.fonts?.textBig};
  font-weight: 700;
  margin-left: 8px;
`;
